module.exports = __webpack_public_path__ + "static/media/solid-arrow.db1447c2.svg";